import { RowExportTypeExcel } from "types";
import { excel } from "utils";
import { Payload } from "../../types/CurrentStockPositionValue";


export function ExportExcelStockPositionValue({ dataList }: {
  dataList: Payload['data'],
}) {
  const columns = [
    { header: 'NO', key: 'no', width: 5 },
    { header: 'CODE', key: 'code', width: 10 },
    { header: 'PRODUCT NAME', key: 'product_name', width: 20 },
    { header: 'RETAIL VALUE', key: 'retail_value', width: 20 },
    { header: 'COGM VALUE', key: 'cogm_value', width: 20 },
    { header: 'AVG VALUE', key: 'avg_value', width: 20 },
    { header: 'GMP %', key: 'gmp', width: 20 },
    { header: 'PROFIT', key: 'profit', width: 20 },
  ];

  const dataMap: RowExportTypeExcel[] = dataList.map((item, index: number) => {

    return {
      no: index + 1,
      code: item.product_barcode,
      product_name: item.product_name,
      retail_value: {
        text: Number(item.retail_value),
        style: {
          numFmt: '#,##0',
        }
      },
      cogm_value: {
        text: Number(item.cogm_value),
         style: {
          numFmt: '#,##0',
        }
      },
      avg_price: {
        text: Number(item.avg_price),
         style: {
          numFmt: '#,##0',
        }
      },
      gmp: {
        text: item?.soh && item?.soh > 0 && item?.retail_value ? `${Number((item?.retail_value - item?.cogm_value) / item?.retail_value * 100).toFixed(2)}%` : "0",
         style: {
          numFmt: '#,##0',
        }
      },
      profit: {
        text: Number(item.retail_value) - Number(item.cogm_value),
         style: {
          numFmt: '#,##0',
        }
      },
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: 'INVENTORI',
    title: 'CURRENT STOCK POSITION VALUE',
    fileName: 'Current_Stock_Position_Value',
  });
}

